import * as React from 'react';
import {
    AdvancedTable, AdvancedTableHeader, AscDetailsInfo, Card, WarningModal,
} from 'components';
import { Dispatch, IRootState } from '../../redux/store/configureStore';
import { connect } from 'react-redux';
import { useEffectProcessing, useMultiSearch } from 'hooks';
import { IFilterPart, ISearchPart } from 'components/models';
import { PaginationImpl } from 'components/defaultValues';
import { ExpertContainer } from '../ExpertContainer';

const AscListContainer: React.FC<IProps> = (props) => {
    const { filters, changeFilter } = useMultiSearch<ISearchPart & IFilterPart>(props.getAttestationSubCommissions, {});
    const [showInfo, setShowInfo] = React.useState(false);

    const processing = useEffectProcessing(
      () => props.getAttestationSubCommissions(filters),
      [],
      () => { props.clearAttestationSubCommissions(); },
    );

    const tableData = props.attestationSubCommissions ? props.attestationSubCommissions.items.map(ac => ({
        id: ac.id,
        columns: [
            ac.qualificationTitle,
            ac.regionName,
            ac.chairmanFullName || '-',
        ],
    })) : [];

    const tableHeaders: AdvancedTableHeader[] = [
        { fieldName: 'qualificationTitle', title: 'СПЕЦИАЛЬНОСТЬ' },
        { fieldName: 'regionName', title: 'РЕГИОН' },
        { fieldName: 'chairmanFullName', title: 'ПРЕДСЕДАТЕЛЬ АПК' },
    ];

    const pagination = new PaginationImpl(props.attestationSubCommissions || undefined);

    return (
      <Card
        withoutPadding
        title="Список АПК"
        category="Список всех аккредитационных подкомиссий"
        apiError={props.apiError}
        showLoader={processing}
      >
          <AdvancedTable
            data={tableData}
            tableHeaders={tableHeaders}
            handleRowClick={(id: string) => {
                props.getAttestationCommissionDetails(id);
                setShowInfo(true);
            }}
            filters={filters.searchField && filters.searchTerm ? {
                searchField: filters.searchField,
                searchTerm: filters.searchTerm,
            } : null}
            handleSearch={(f, t) => changeFilter({ searchField: f, searchTerm: t })}
            handleOrder={(sortField => changeFilter({
                sortField,
                sortOrder: filters.sortField === sortField ? !filters.sortOrder : true,
            }))}
            handlePageChange={d => changeFilter({ page: d.page, pageSize: d.perPage })}
            page={pagination.page}
            pageSize={pagination.pageSize}
            total={pagination.total}
          />

          <WarningModal
            large
            card
            title={props.attestationSubCommissionDetails ? props.attestationSubCommissionDetails.fullName : ''}
            show={showInfo}
            onHide={() => {
                props.clearAttestationSubCommissionDetails();
                setShowInfo(false);
            }}
            withoutCancelButton
          >
              {props.attestationSubCommissionDetails && (
                <AscDetailsInfo
                  ascDetails={props.attestationSubCommissionDetails}
                  ascId={props.attestationSubCommissionDetails.id}
                  getExperts={props.getExperts}
                  ascExperts={props.experts}
                  renderExpertDetails={(id => (
                    <ExpertContainer expertId={id} />
                  ))}
                />
              )}
          </WarningModal>
      </Card>
    );
};


const mapStateToProps = (state: IRootState) => ({
    apiError: state.errors.error,
    attestationSubCommissions: state.asc.ascList,
    attestationSubCommissionDetails: state.asc.ascDetails,
    experts: state.experts.experts,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    getAttestationSubCommissions: dispatch.asc.getAscAsync,
    getAttestationCommissionDetails: dispatch.asc.getAscDetailsAsync,
    clearAttestationSubCommissions: () => dispatch.asc.setAsc(null),
    clearAttestationSubCommissionDetails: () => dispatch.asc.setAscDetails(null),
    getExperts: dispatch.experts.getExperts,
});

type ConnectedProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;
type IProps = ConnectedProps;

export default connect(mapStateToProps, mapDispatchToProps)(AscListContainer);
